import React, {useState, useEffect} from 'react';
import styles from '../../../styles.module.scss';
import {Text, Dropdown} from '@priority-software/priority-style-react';
import {SearchDropdown} from '../../../../../components/commonOldtoNew';
import List from '../../../../../components/Common/List';
import texts from '../../../texts';
import {highlightText} from '../../../../../_legacy/library/utils/highlightText';
import {reportGeneratorsStore} from '../../../stores/ReportGeneratorsStore';

const AxisSelector = ({title, options, onSelect, axisName, helpText, placeholder}) => {
    const {currentReport} = reportGeneratorsStore.currentScreen;
    const [isOpen, setIsOpen] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [query, setQuery] = useState<string>();
    const [selectedIndex, setselectedIndex] = useState<number>();

    const handleSelectItem = item => {
        setIsOpen(false);
        onSelect(item.Title);
        setselectedIndex(filteredOptions.findIndex(opt => opt.Title === item.Title));
        onSelect(item);
    };

    useEffect(() => {
        handleClose();
    }, [currentReport]);

    const handleClose = () => {
        setIsOpen(false);
        setQuery(null);
    };

    useEffect(() => {
        if (query) {
            const lowerCaseQuery = query.toLowerCase();
            const newFilteredOptions = options.filter(item =>
                item.Title.toLowerCase().includes(lowerCaseQuery)
            );
            setFilteredOptions(newFilteredOptions);
        } else {
            setFilteredOptions(options);
        }
    }, [query, options]);

    useEffect(() => {
        setselectedIndex(filteredOptions.findIndex(opt => opt.Title === axisName));
    }, [filteredOptions]);

    const handlePageDown = (index: number) => {
        const lastIndex = filteredOptions.length - 1;
        let nextIndex = Number(index) + 10;
        nextIndex = nextIndex > lastIndex ? lastIndex : nextIndex;
        return Promise.resolve({nextSelected: nextIndex});
    };

    const handlePageUp = selectedIndex => {
        let nextIndex = selectedIndex - 10;
        nextIndex = nextIndex >= 0 ? nextIndex : 0;
        return nextIndex;
    };

    const focsedIndex = query ? 0 : selectedIndex > -1 ? selectedIndex : 0;

    return (
        <div className={styles.axisWrapper}>
            <Text skin="label-1">{title}</Text>
            <SearchDropdown
                openOnFocus
                onOpen={() => setIsOpen(true)}
                focusedIndex={focsedIndex}
                clearOnClose={false}
                closeOnClear={false}
                closeOnBlur={false}
                shouldHandleHomeAndEndPress
                selectedIndex={selectedIndex}
                handlePageDown={handlePageDown}
                handlePageUp={handlePageUp}
                inputProps={{
                    value: query ?? axisName,
                    onChange: setQuery,
                    returnFocus: false,
                    displayClear: isOpen,
                    placeholder: placeholder,
                    autoSelect: true,
                    size: 'large',
                    componentClasses: styles.searchInput
                }}
                onClose={handleClose}
                circularNavigation
                withDataTestId
            >
                <Dropdown.Content componentClasses={styles.fieldsList}>
                    <Dropdown.Section gradient>
                        {filteredOptions?.length > 0 ? (
                            <List
                                onScrollToEnd={() => {}}
                                autoHeight
                                autoHeightMax={200}
                                data={filteredOptions}
                                renderItem={({item, index}) => (
                                    <Dropdown.Item
                                        divider={
                                            filteredOptions && index !== filteredOptions.length - 1
                                        }
                                        onClick={() => handleSelectItem(item)}
                                        key={index}
                                        index={index}
                                    >
                                        <Text skin="paragraph-2" style={{color: 'black'}}>
                                            {highlightText(item.Title, query, true, false, true)}
                                        </Text>
                                    </Dropdown.Item>
                                )}
                            />
                        ) : (
                            <Dropdown.Item disabled>
                                <Text componentClasses={styles.emptState} skin="paragraph-2">
                                    {texts.noMatchEmptyResults}
                                </Text>
                            </Dropdown.Item>
                        )}
                    </Dropdown.Section>
                </Dropdown.Content>
            </SearchDropdown>
        </div>
    );
};

export default AxisSelector;
